export interface InventorySnapshotContainerRow {
  id: string;
  shortCode: string;
  quantity: number;
  sublocation: string;
}

/**
 * Hover rows are the live UUID containers. The cell is those bin labels with
 * duplicates removed, in the order they first appear in the hover.
 */
export function inventorySnapshotSublocationPresentation(
  containers: InventorySnapshotContainerRow[] | undefined,
): { label: string; rows: InventorySnapshotContainerRow[] } {
  const rows = (containers ?? []).filter(
    (row) => row.sublocation.trim().length > 0 && row.quantity > 0,
  );
  const unique: string[] = [];
  const seen = new Set<string>();
  for (const row of rows) {
    const label = row.sublocation.trim();
    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push(label);
  }
  const label = unique.length === 0 ? "—" : unique.join("; ");
  return { label, rows };
}
